/**
 * Created by lu on 2018/2/1.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    parent:nb.Model,
    mapping:{
        productList:require('./ProductList')
    },
    method:{
        init:function () {
            this.onChange('imageUrl',function (inEvent,inUrl) {
                this.set('image',inUrl+'?x-image-process=image/resize,m_fill,h_680,w_1440,limit_0');
            },this);
            this.onChange('id',function (inEvent,inId) {
                this.set('seriesHref',"series.html?id=" + inId);
            },this);

            this.onChange('proList',function (inEvent,inList) {
               this.set('productList',{
                   items:inList || []
               });
            },this);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/SeriesListItem.js
// module id = 173
// module chunks = 1 4